export type UiRoute = "home" | "projects" | "tools" | "settings" | "chat" | "files" | "browser" | "canvas" | "taskboard" | "cost" | "memory" | "quarantine" | "recipes" | "archmap" | "benchmark" | "drift" | "provenance" | "replay" | "registry" | "access" | "blog" | "notebook";

export type UiBootstrap = {
  route: UiRoute;
  projectName?: string;
  payload?: unknown;
};

declare global {
  interface Window {
    __OPENTOOL_BOOTSTRAP__?: UiBootstrap;
  }
}

export function readBootstrap(): UiBootstrap {
  return window.__OPENTOOL_BOOTSTRAP__ ?? { route: "home", projectName: "workspace" };
}

export function subscribeBootstrap(listener: (bootstrap: UiBootstrap) => void) {
  const handler = (event: Event) => {
    const custom = event as CustomEvent<UiBootstrap>;
    listener(custom.detail ?? readBootstrap());
  };
  window.addEventListener("opentool-bootstrap", handler as EventListener);
  return () => window.removeEventListener("opentool-bootstrap", handler as EventListener);
}
